import { PeopleMerchantGroupDto } from "./people-merchant-group.dto";
import { PeopleQueryBaseDto } from "./people-query-base.dto";

export class PeoplePayTypeDto {
  id?: number;
  merchantGroupId?: number;
  merchantGroup?: PeopleMerchantGroupDto;
  name?: string;
  code?: string;
  createdDate?: Date;
  modifiedDate?: Date;
  lastModifiedUserId?: number;
  version?: number;
}

export interface PeoplePayTypeQueryDto extends PeopleQueryBaseDto {
  name?: string;
  merchantGroupId?: number;
  join?: string | string[];
}